// components
import GridPageAbstract from '../../abstract/GridPageAbstract';

export default class FiltersBinsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'filtersBins';
        this.Server = this.props.context.getState().server.filtersBins;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['bank', 'card', 'website', 'phone'];
        this.showDatePicker = false;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'bin',
                    label: 'bin',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'bin4',
                    label: 'bin4',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'bank',
                    label: 'bank',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'card',
                    label: 'card',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'type',
                    label: 'type',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'level',
                    label: 'level',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'country',
                    label: 'country',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'countryCode',
                    label: 'countryCode',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'website',
                    label: 'website',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'phone',
                    label: 'phone',
                    alignRight: false,
                    cell: 'Phone',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'valid',
                    label: 'valid',
                    alignRight: false,
                    cell: 'Checkbox',
                    type: 'boolean',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'executedCount',
                    label: 'executedCount',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'rejectedCount',
                    label: 'rejectedCount',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'conversionRate',
                    label: 'conversionRate',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'isBlacklisted',
                    label: 'isBlacklisted',
                    alignRight: false,
                    cell: 'Checkbox',
                    type: 'boolean',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'chargebacksCount',
                    label: 'chargebacksCount',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'holderType',
                    label: 'holderType',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                },
                {
                    id: 'walletMccAllowed',
                    label: 'walletMccAllowed',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
